<template>
    <div class="workFlowContainer">
        <!-- 新闻中心 -->
        <van-nav-bar
            title="审批流"
            left-text
            left-arrow
            @click-left="onClickLeft"
            :fixed="true"
        >
        
        </van-nav-bar>
        <div class="workFlowIndexBox">
            <mainInfo></mainInfo>
        </div>
    </div>
</template>

<script>
// 主表信息
import mainInfo from './mainInfo.vue'
export default {
    name: 'ApprovalFlow',
    // data函数返回一个对象，这个对象的属性会被绑定到模板上
    data() {
        return {
            // 这里可以添加你需要的数据
        }
    },
    components:{
        mainInfo
    },
    //  methods函数返回一个对象，这个对象的属性和方法会被绑定到模板上
    methods: {
        onClickLeft () {

        }
    },
    // computed函数返回一个对象，这个对象的属性会被绑定到模板上
    computed: {
        // 这里可以添加你需要计算的数据
    },
    // watch函数返回一个对象，这个对象的属性和方法会被绑定到模板上
    watch: {
        // 这里可以添加你需要监听的数据
    }
}
</script>

<style lang="less" scoped>
.workFlowContainer{
    .van-nav-bar {
        background: #2b8df0;

        /deep/.van-nav-bar__left {
            .van-icon {
                color: #fff;
            }
        }
        /deep/.van-nav-bar__title {
            color: #fff;
            font-size: 36px;
            font-family: Source Han Sans CN;
        }
    }
    .workFlowIndexBox{
        margin-top: 1.22667rem;
    }
}
</style>